import { C, Mark, Plant } from "@/components/illustrations/kit";

const Frame = ({ children }) => (
  <svg viewBox="0 0 240 150" className="block h-auto w-full" aria-hidden="true">
    <rect x="20" y="16" width="200" height="134" rx="12" fill="#FFFFFF" stroke={C.line} strokeWidth="2" />
    <circle cx="34" cy="29" r="3" fill={C.grey} />
    <circle cx="44" cy="29" r="3" fill={C.grey} />
    <circle cx="54" cy="29" r="3" fill={C.em} />
    {children}
  </svg>
);

export const IlloBusiness = () => (
  <Frame>
    <Mark x={34} y={44} s={12} />
    <rect x="160" y="47" width="46" height="6" rx="3" fill={C.grey} />
    <rect x="34" y="68" width="84" height="9" rx="3" fill={C.ink} />
    <rect x="34" y="82" width="60" height="9" rx="3" fill={C.ink} />
    <rect x="34" y="100" width="40" height="13" rx="6.5" fill={C.em} />
    <g className="svc-move svc-up">
      <rect x="130" y="64" width="76" height="72" rx="8" fill={C.mint} />
      <Plant x={168} y={128} s={0.5} />
    </g>
  </Frame>
);

export const IlloLanding = () => (
  <Frame>
    <rect x="58" y="48" width="124" height="10" rx="3" fill={C.ink} />
    <rect x="76" y="63" width="88" height="10" rx="3" fill={C.ink} />
    <rect x="84" y="80" width="72" height="5" rx="2.5" fill={C.grey} />
    <g className="svc-move svc-pop">
      <rect x="86" y="96" width="68" height="20" rx="10" fill={C.em} />
    </g>
    <g className="svc-move svc-right">
      <path d="M150 108 l0 20 l5 -4.5 l4 8.5 l4 -1.6 l-4 -8.4 l7 -0.8z" fill={C.ink} stroke="#fff" strokeWidth="1.6" strokeLinejoin="round" />
    </g>
    <rect x="34" y="128" width="172" height="10" rx="5" fill={C.soft} />
  </Frame>
);

export const IlloShop = () => (
  <Frame>
    {[0, 1, 2].map((i) => (
      <g key={i}>
        <rect x={34 + i * 58} y="46" width="50" height="58" rx="7" fill={i === 1 ? C.mint : C.soft} stroke={C.line} />
        <circle cx={59 + i * 58} cy="70" r="11" fill={i === 1 ? C.em : C.leaf} />
        <rect x={40 + i * 58} y="110" width="34" height="5" rx="2.5" fill={C.ink} opacity="0.75" />
        <rect x={40 + i * 58} y="120" width="22" height="5" rx="2.5" fill={C.em} />
      </g>
    ))}
    <g className="svc-move svc-pop">
      <circle cx="200" cy="42" r="14" fill={C.ink} />
      <path d="M193 38 h3 l2.4 9 h7 l2 -6 h-10" stroke="#fff" strokeWidth="1.8" fill="none" strokeLinecap="round" strokeLinejoin="round" />
      <circle cx="210" cy="32" r="6" fill={C.em} />
    </g>
  </Frame>
);

export const IlloApp = () => (
  <Frame>
    <rect x="20" y="38" width="44" height="112" fill={C.ink} />
    <rect x="30" y="50" width="24" height="5" rx="2.5" fill={C.em} />
    <rect x="30" y="64" width="20" height="5" rx="2.5" fill="#3A4540" />
    <rect x="30" y="76" width="22" height="5" rx="2.5" fill="#3A4540" />
    <rect x="76" y="48" width="56" height="5" rx="2.5" fill={C.ink} opacity="0.75" />
    {[0, 1, 2, 3, 4].map((i) => (
      <rect key={i} className="svc-move svc-grow" x={78 + i * 18} y={130 - (18 + ((i * 11) % 34))} width="10" height={18 + ((i * 11) % 34)} rx="2" fill={i === 3 ? C.em : C.leaf} />
    ))}
    <path d="M170 116 l10 -10 l8 6 l14 -20" stroke={C.em} strokeWidth="2.5" fill="none" strokeLinecap="round" strokeLinejoin="round" />
    <rect x="166" y="48" width="40" height="22" rx="5" fill={C.soft} stroke={C.line} />
  </Frame>
);

export const SERVICE_ILLOS = {
  "business-websites": IlloBusiness,
  "landing-pages": IlloLanding,
  "e-commerce": IlloShop,
  "custom-web-apps": IlloApp,
};
